"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadableShapePainter = void 0;
var executeSvgPath_1 = require("../../../util/executeSvgPath");
var ShapePainter_1 = require("../ShapePainter");
var antiAliasSize = 1;
var LoadableShapePainter = /** @class */ (function (_super) {
    __extends(LoadableShapePainter, _super);
    function LoadableShapePainter(_loadShape) {
        var _this = _super.call(this, "loadable-shape") || this;
        _this._loadShape = _loadShape;
        _this.baseWidthOf = function (object) { return object.width; };
        _this.baseHeightOf = function (object) { return object.height; };
        return _this;
    }
    LoadableShapePainter.prototype.loadResources = function (store, object) {
        var _this = this;
        store.load("shape", function () { return _this._loadShape(object.url); }, { hash: object.url });
    };
    LoadableShapePainter.prototype.tracePath = function (ctx, store, object) {
        var e_1, _a;
        var shapeResource = store.require("shape");
        if (shapeResource.status !== "loaded") {
            return;
        }
        var shape = shapeResource.result;
        ctx.save();
        ctx.translate(0.5, 0.5);
        ctx.scale((this.scaledBaseWidthOf(object) - antiAliasSize) / shape.viewBox.width, (this.scaledBaseHeightOf(object) - antiAliasSize) / shape.viewBox.height);
        ctx.beginPath();
        try {
            for (var _b = __values(shape.paths), _c = _b.next(); !_c.done; _c = _b.next()) {
                var path = _c.value;
                executeSvgPath_1.executeSvgPath(path, ctx);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        ctx.closePath();
        ctx.restore();
    };
    LoadableShapePainter.prototype.shouldRepaint = function (previousData, newData) {
        return _super.prototype.shouldRepaint.call(this, previousData, newData)
            || newData.url !== previousData.url;
    };
    LoadableShapePainter.prototype.needsMiterOvershoot = function (object) {
        return true;
    };
    LoadableShapePainter.prototype.canWriteSvg = function (object) {
        return !object.shadow && !object.stroke;
    };
    LoadableShapePainter.prototype.writeSvg = function (ctx, store, object) {
        var shapeResource = store.require("shape");
        if (shapeResource.status !== "loaded") {
            return;
        }
        var shape = shapeResource.result;
        ctx.save();
        this.applyDeviceScales(ctx, store.layers.device);
        ctx.scale(this.scaledBaseWidthOf(object) / shape.viewBox.width, this.scaledBaseHeightOf(object) / shape.viewBox.height);
        var svgString = this._toSvgString(shape, object.fillStyle);
        ctx.unsafeInsertSvg(svgString);
        ctx.restore();
    };
    LoadableShapePainter.prototype._toSvgString = function (shape, fill) {
        var e_2, _a;
        var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("viewbox", "0 0 " + shape.viewBox.width + " " + shape.viewBox.height);
        svg.setAttribute("width", shape.viewBox.width + "px");
        svg.setAttribute("height", shape.viewBox.height + "px");
        try {
            for (var _b = __values(shape.paths), _c = _b.next(); !_c.done; _c = _b.next()) {
                var path = _c.value;
                var pathElement = document.createElement("path");
                pathElement.setAttribute("d", path);
                pathElement.setAttribute("style", "fill:" + fill);
                svg.append(pathElement);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return svg.outerHTML;
    };
    return LoadableShapePainter;
}(ShapePainter_1.ShapePainter));
exports.LoadableShapePainter = LoadableShapePainter;
//# sourceMappingURL=LoadableShapePainter.js.map